/**
 * Trạng thái nộp dự toán
 */
export default {

    /**
     * Chưa nộp
     */
    NotSent: 0,
    /**
     * Chưa kiểm tra
     */
    NotCheck: 5,
    /**
     * Đang kiểm tra
     */
    Checking: 10,
    /**
     * Đã gửi trả
     */
    Return: 15,
    /**
     * Đã hoàn thành
     */
    Complete: 20,
    /**
     * Cấp dưới yêu cầu nộp
     */
    RequestRevoke:25
};
